import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue")
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import("../views/Contact.vue")
  },
  {
    path: "/data-privacy",
    name: "DataPrivacy",
    component: () => import("../views/DataPrivacy.vue")
  },
  {
    path: "/legal-notices",
    name: "LegalNotices",
    component: () => import("../views/LegalNotices.vue")
  },
  {
    path: "/post/:post",
    name: "BlogItem",
    component: () => import("../views/BlogItem.vue")
  },
  {
    path: "/documentations",
    name: "Documentations",
    component: () => import("../views/Documentations.vue")
  },
  {
    path: "/financial-press",
    name: "FinancialPress",
    component: () => import("../views/FinancialPress.vue")
  },
  {
    path: "/share-information",
    name: "ShareInformation",
    component: () => import("../views/ShareInformation.vue")
  },
  {
    path: "/career",
    name: "Career",
    component: () => import("../views/Career.vue")
  },
  {
    path: "/shareholders-meeting",
    name: "ShareholdersMeeting",
    component: () => import("../views/ShareholdersMeeting.vue")
  },
  {
    path: "/team",
    name: "Team",
    component: () => import("../views/Team.vue")
  },
  {
    path: "/engagement",
    name: "Engagement",
    component: () => import("../views/Engagement.vue")
  },
  {
    path: "/mission",
    name: "Mission",
    component: () => import("../views/Mission.vue")
  },
  {
    path: "/identity",
    name: "Identity",
    component: () => import("../views/Identity.vue")
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash) {

      return { el: to.hash, behavior: 'smooth' }
    }
    return { top: 0 }
  }
})

export default router